//     Search logic
//
//     Usage:
//     <w3-search></w3-search>

/* Get locale for endpoint */
const SHOPIFY_LOCALE = Shopify.locale == 'fr' ? '' : `/${Shopify.locale}`

class Search extends HTMLElement {
    constructor() {
        super();

        this.bindEvents = this.bindEvents.bind(this);
        this.userTyping = this.userTyping.bind(this);
        this.getCollectionsSuggestions = this.getCollectionsSuggestions.bind(this);
        this.getSearchContent = this.getSearchContent.bind(this);
        this.resetSearch = this.resetSearch.bind(this);
        this.focusInputSearch = this.focusInputSearch.bind(this);
        this.preventLoadMore = this.preventLoadMore.bind(this);
        this.handleMobileNavOpener = this.handleMobileNavOpener.bind(this);
    }

    connectedCallback() {
        // DOM
        this.Search = this;
        this.searchForm = this.Search.querySelector('form')
        this.searchInput = this.querySelector('.js-input-search');
        this.searchInputReset = this.querySelector('.js-input-search-reset');
        this.searchContainerId = this.Search.dataset.searchContainerId;
        this.searchInputFocus = document.querySelector('.js-focus-search-input');
        this.searchGridContainer = document.querySelector(`#${this.searchContainerId}`);

        this.searchInputValue = this.searchInput.value;
        this.isSearchInit = false;
        this.timeout = null;
        this.isSearchDrawer = this.Search.hasAttribute('data-search-drawer');

        this.mobileBreakpoint = 1024;
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;

        // append suggestion on page load if already has term in query
        if (this.searchInputValue !== '') {
            this.getCollectionsSuggestions();
        }

        this.bindEvents();
    }

    bindEvents() {
        if (this.searchInput) {
            this.searchInput.addEventListener('keyup', this.userTyping);
        }

        if (this.searchInputReset) {
            this.searchInputReset.addEventListener('click', this.resetSearch);
        }

        if (this.searchInputFocus) {
            this.searchInputFocus.addEventListener('click', this.focusInputSearch);
        }

        if (this.isSearchDrawer) {
            this.searchDrawer = document.querySelector('w3-drawer.drawer-search');
            this.searchDrawer.addEventListener('drawer--open', this.focusInputSearch);
        }

        if (this.isSearchDrawer && this.isMobile) {
            this.searchDrawerOpener = document.querySelector('.js-custom-open-drawer-search');
            this.searchDrawerOpener.addEventListener('click', this.handleMobileNavOpener);
        }
    }

    // use a special method to handle search drawer opening from mobile navigation
    // prevent conlicts between drawer navigation and drawer search logic
    handleMobileNavOpener() {
        if (this.searchDrawer.isDrawerOpen) { return; }

        setTimeout(() => {
            this.searchDrawer.openDrawer();
        }, 420); // do not change less than 400 - value from navigation drawer speed
    }

    // on search drawer, load more button submit form and redirect to search page
    preventLoadMore() {
        this.searchLoadMore = this.searchGridContainer.querySelector('w3-load-more');

        if (!this.searchLoadMore) { return; }
        this.searchLoadMore.addEventListener('click', (e) => {
            e.preventDefault(e);
            this.searchForm.submit();
        });
    }

    focusInputSearch() {
        this.searchInput.focus();
    }

    resetSearch() {
        this.searchInput.value = '';
        this.searchInputValue = '';
        this.searchInput.blur();
        this.isSearchInit = false;
        const url = new URL(location);
        window.history.replaceState(null, null, '?q=');
        this.getSearchContent();
    }

    userTyping(e) {
        if (e.key !== 'Enter' && e.key !== 13) {
            if (!this.isSearchDrawer) {
                window.history.replaceState(null, null, `?q=${this.searchInput.value}&type=product`);
            }

            // prevent method to run if value didn't change and just a white space
            if (this.searchInput.value.replace(/ /g,'') === this.searchInputValue.replace(/ /g,'')) { return; }

            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            this.timeout = setTimeout(() => {
                this.isSearchInit = true;
                this.searchInputValue = this.searchInput.value;
                this.getSearchContent();
            }, 300);
        }
    }

    async getSearchContent() {
        await fetch(`${routes.root_url != "/" ? routes.root_url + '/' : '/' }search?q=${this.searchInput.value}&view=ajax&type=product&options[prefix]=last&options[unavailable_products]=last`)
            .then(response => response.text())
            .then((html) => {
                // get next DOM before injecting it to page
                const DOM = new DOMParser().parseFromString(html, 'text/html');
                const nextSearchGridContainer = DOM.querySelector(`#${this.searchContainerId}`);

                // replace HTML
                this.searchGridContainer.innerHTML = nextSearchGridContainer.innerHTML;

                // add event listener to load more button
                if (this.isSearchDrawer) { this.preventLoadMore(); }

                // fetch collections suggestions and replace HTML
                this.getCollectionsSuggestions();

                // load lozad
                window.lozadObserver.observe();

            })
            .catch(function(error) {
                console.error(error);
            });
    }

    async getCollectionsSuggestions() {
        if (this.searchInput.value === '') { return; }

        await fetch(`${routes.root_url != "/" ? routes.root_url + '/' : '/' }search/suggest.json?q=${this.searchInput.value}&resources[type]=collection`)
            .then(response => response.json())
            .then((response) => {
                let suggestions = response.resources.results.collections;

                if (suggestions.length > 0) {
                    this.appendSuggestions(suggestions);
                }
            })
            .catch(function(error) {
                console.error(error);
            });
    }

    appendSuggestions(suggestions) {
        const collectionSuggestionsContainer = this.searchGridContainer.querySelector('.js-search-collection-suggestions');
        for (let i = 0; i < suggestions.length; i++) {
            // exclude seo_hidden collections
            if (!suggestions[i].title.includes('-')) {
                collectionSuggestionsContainer.innerHTML += `
                <li>
                <a href="${suggestions[i].url}" class="link u-underline u-nowrap u-uppercase">${suggestions[i].title.replace('|', ' ')}</a>
                </li>
                `
            }
        }
    }
};

customElements.define('w3-search', Search);
